import { Injectable } from '@angular/core';
import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ListArchivosService {
  urlGetArchivosMarkList: string = '/api-mark-list/getArchivosMarkList';

  constructor(private restclient: AvlaRestClientService) {}

  public getArchivosMarkList(): Observable<any> {
    return this.restclient.getList(this.urlGetArchivosMarkList, [], null);
  }
}
